var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social-Media-Collection"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Youtube"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-207",
    d: "M33,22.83a33.285,33.285,0,0,1-.22,3.561,4.757,4.757,0,0,1-.874,2.183,3.142,3.142,0,0,1-2.2.931c-3.079.223-7.7.23-7.7.23s-5.72-.052-7.48-.22a3.732,3.732,0,0,1-2.425-.941,4.757,4.757,0,0,1-.875-2.183A33.285,33.285,0,0,1,11,22.83V21.161a33.243,33.243,0,0,1,.22-3.56,4.76,4.76,0,0,1,.875-2.185,3.142,3.142,0,0,1,2.2-.931c3.079-.223,7.7-.223,7.7-.223H22s4.619,0,7.7.223a3.142,3.142,0,0,1,2.2.931A4.76,4.76,0,0,1,32.78,17.6a33.242,33.242,0,0,1,.22,3.56ZM22,0A22,22,0,1,0,44,22,22,22,0,0,0,22,0Z",
    fill: "#ea412c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-208",
    d: "M28.7,33.34l5.944-3.08-5.945-3.1Z",
    transform: "translate(-8.967 -8.487)",
    fill: "#ea412c",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.12b3ca82f949f04a7df901ac9ab84274.svg";
export { ForwardRef as ReactComponent };